var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c("div", { staticStyle: { color: "red" } }, [
        _vm._v("请输入微信号或者手机号进行搜索并选择！"),
      ]),
      _c(
        "avue-crud",
        _vm._g(
          _vm._b(
            {
              attrs: { page: _vm.page },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "refresh-change": _vm.refreshChange,
                "search-reset": _vm.searchChange,
                "search-change": _vm.searchChange,
              },
              scopedSlots: _vm._u([
                {
                  key: "menu",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.onCheck(row)
                            },
                          },
                        },
                        [_vm._v("选择")]
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.formData,
                callback: function ($$v) {
                  _vm.formData = $$v
                },
                expression: "formData",
              },
            },
            "avue-crud",
            _vm.bindVal,
            false
          ),
          _vm.onEvent
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }